import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { TemplatePreviewSelectableOptions } from "@app/models";
import { DigitalAssetScreenSize } from "clearline-api";
import { ItemWithLabel } from "clearline-common";

@Component({
  selector: "app-cfs-templates-preview-grid",
  templateUrl: "./cfs-templates-preview-grid.component.html",
  styleUrls: ["./cfs-templates-preview-grid.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CfsTemplatesPreviewGridComponent {
  @Input() items: TemplatePreviewSelectableOptions[] = [];
  @Input() tabs: ItemWithLabel<DigitalAssetScreenSize>[] = [];
  @Input() screenSize: DigitalAssetScreenSize;
  @Input() selectedItemId: number;
  @Input() loading = false;

  @Output() selectItem = new EventEmitter<number>();
  @Output() screenSizeChange = new EventEmitter<DigitalAssetScreenSize>();

  clickSelectItem(item: TemplatePreviewSelectableOptions): void {
    if (item.disabledInfo) {
      return;
    }

    if (!this.selectedItemId || this.selectedItemId !== item.id) {
      this.selectedItemId = item.id;
      this.selectItem.emit(item.id);
    } else if (this.selectedItemId && this.selectedItemId === item.id) {
      this.selectedItemId = null;
      this.selectItem.emit(null);
    }
  }

  onScreenSizeChange(tab: ItemWithLabel<DigitalAssetScreenSize>): void {
    this.screenSizeChange.emit(tab.value as DigitalAssetScreenSize);
  }
}
